import React from 'react';
import PropTypes from 'prop-types';
import PageFooter from '../PageFooter/PageFooter';
import PageHeader from '../PageHeader/PageHeader';

const MarkdownPageRenderer = ({ MarkdownContent }) => {
  return (
    <div className="fixed inset-0 flex flex-col font-sans text-lg overflow-auto scrollbar-hidden">
      <PageHeader />

      <main className="flex-grow px-6 max-w-400 mx-auto pt-32 pb-12 w-full">
        <div className="max-w-400 mx-auto">
          <MarkdownContent
            components={{
              h1: ({ children, ...props }) => (
                <h1
                  className="text-2xl font-sans font-bold mt-10 first:mt-0"
                  {...props}
                >
                  {children}
                </h1>
              ),
              h2: ({ children, ...props }) => (
                <h2
                  className="text-xl font-sans font-bold mt-8"
                  {...props}
                >
                  {children}
                </h2>
              ),
              p: ({ children, ...props }) => (
                <p
                  className="mt-4 leading-7 text-left"
                  {...props}
                >
                  {children}
                </p>
              ),
              ul: ({ children, ...props }) => (
                <ul
                  className="list-disc ml-6 mt-3 space-y-2 leading-7"
                  {...props}
                >
                  {children}
                </ul>
              ),
              ol: ({ children, ...props }) => (
                <ol
                  className="list-decimal ml-6 mt-3 space-y-2 leading-7"
                  {...props}
                >
                  {children}
                </ol>
              ),
              li: ({ children, ...props }) => (
                <li
                  className="ml-1"
                  {...props}
                >
                  {children}
                </li>
              ),
              hr: (props) => (
                <hr
                  className="my-8 border-t border-vamos-light-gray"
                  {...props}
                />
              ),
              a: ({ href, children, ...props }) => {
                const isExternal = href?.startsWith('http');

                return (
                  <a
                    href={href}
                    target={isExternal ? '_blank' : undefined}
                    rel={isExternal ? 'noreferrer noopener' : undefined}
                    className="underline break-words text-vamos-green4 hover:text-vamos-green1"
                    {...props}
                  >
                    {children}
                  </a>
                );
              },
            }}
          />
        </div>
      </main>

      <PageFooter />
    </div>
  );
};

MarkdownPageRenderer.propTypes = {
  MarkdownContent: PropTypes.elementType.isRequired,
};

export default MarkdownPageRenderer;
